<div class="p-grid p-ai-top p-ai-stretch vertical-container" style="margin:20px">
    <div class="p-col" style="padding-bottom: 0px">
        <div class="p-grid" style="padding:0px 0px 0px 10px;">
            <div class="p-col-12" style="padding-bottom: 0px">
                <div class="p-grid" style="padding:0px 0px 0px 0px;">
                    <div class="p-col-12 donor-view" style="margin-bottom:20px; max-height: 62px; text-align: left;">
                        <div class="p-grid">
                            <div class="p-col-12 p-d-flex p-ai-center p-jc-start" style="min-height: 60px;">
                                <span style="margin-left: 20px; margin-right: 20px;">Measurements: </span>
                                <p-selectButton [options]="measureOptions" [(ngModel)]="measureType" optionLabel="label" optionValue="value" (onChange)="main()"></p-selectButton>
                            </div>                      
                        </div>
                    </div>
                </div>
            </div>
            <div  class="p-col-4" style="padding-bottom: 0px">
                <div class="p-grid" style="padding:0px 10px 0px 0px; min-height: 626px;">
                    <div class="p-col-12 donor-view"  style="text-align: center;">
                        <div style="text-align: center; margin-top:40px; margin-bottom: 20px">
                            <span style="font-size: 1.5rem; font-weight: 600;">C-peptide concentration</span> 
                        </div>
                        <div>
                            <span style="text-align: center;font-size: 1.2rem;">Average Value:  </span>
                            <span *ngIf="donorInf[[measureType]].cp.value != 'NA'" style="font-size: 1.3rem; font-weight: 300;">  {{donorInf[[measureType]].cp.value}} pM</span>
                            <span *ngIf="donorInf[[measureType]].cp.value == 'NA'" style="font-size: 1.3rem; font-weight: 300;">Not recorded</span>

                        </div>
                        <div id="cpeptideHistogram" class="histogram" style="margin-top: 80px; align-content: center;"></div>
                             <span style="text-align: center;">pM</span>
                    </div>
                </div>
            </div>
            <div class="p-col-4" style="padding-bottom: 0px">
                <div  #myIdentifier class="p-grid" style="padding:0px 10px 0px 0px; min-height: 626px;">
                    <div class="p-col-12 donor-view" style="text-align: center;">
                        <div style="text-align: center; margin-top:40px; margin-bottom: 20px">
                            <span style="font-size: 1.5rem; font-weight: 600;">Proinsulin concentration</span>
                        </div>
                        <div>
                            <span style="text-align: center;font-size: 1.2rem;">Average Value:  </span>
                             <span *ngIf="donorInf[[measureType]].pi.value != 'NA'" style="font-size: 1.3rem; font-weight: 300;">  {{donorInf[[measureType]].pi.value}} pM</span>
                            <span *ngIf="donorInf[[measureType]].pi.value == 'NA'" style="font-size: 1.3rem; font-weight: 300;">Not recorded</span>

                        </div>
                        <div id="proinsulinHistogram" class="histogram" style="margin-top: 80px; align-content: center;"></div>
                          <span style="text-align: center;">pM</span>
                    </div>
                </div>
            </div>
            <div class="p-col-4" style="padding-bottom: 0px">
                <div class="p-grid" style="padding:0px 10px">
                    <div class="p-col-12 donor-view" style="margin-bottom:20px; min-height: 300px; text-align: center;">
                        <div  style="text-align: center; margin-top:15px">
                            <span style="font-size: 1.5rem; font-weight: 600;">C-peptide to Proinsulin Ratio</span>
                        </div>
                        <div>
                            <span style="text-align: center;font-size: 1.2rem;">Value:  </span>
                             <span *ngIf="donorInf[[measureType]].cppiratio.value != 'NA'" style="font-size: 1.3rem; font-weight: 300;">  {{donorInf[[measureType]].cppiratio.value}}</span>
                            <span *ngIf="donorInf[[measureType]].cppiratio.value == 'NA'" style="font-size: 1.3rem; font-weight: 300;">Not recorded</span>
                        </div>
                        <div id="ratio1Histogram" class="histogram" style="margin-top: 20px; align-content: center;"></div>
                        <span style="text-align: center;">Ratio</span>
                    </div>
                    <div class="p-col-12 donor-view" style="margin-bottom:0px; min-height: 300px; text-align: center;">
                        <div  style="text-align: center; margin-top:15px;">
                            <span style="font-size: 1.5rem; font-weight: 600;">Proinsulin to C-peptide Ratio</span>
                        </div>
                        <div>
                            <span style="text-align: center;font-size: 1.2rem;">Value:  </span>
                             <span *ngIf="donorInf[[measureType]].picpratio.value != 'NA'" style="font-size: 1.3rem; font-weight: 300;">  {{donorInf[[measureType]].picpratio.value}}</span>
                            <span *ngIf="donorInf[[measureType]].picpratio.value == 'NA'" style="font-size: 1.3rem; font-weight: 300;">Not recorded</span>

                        </div>
                        <div>
                            <div id="ratio2Histogram" class="histogram" style="margin-top: 20px; align-content: center;"></div>
                            <span style="text-align: center;">Ratio</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
